<template>
    <MyModal ref="myModalRef" title="投诉查看" width="1200px" height="700px">
      <div class="detail-box-uniq-1232311">
        <div class="detail-main-info">
          <MyTitle title="基本信息" :mt0="true" />
          <el-descriptions v-if="1" :column="2" border style="width: 100%">
            <el-descriptions-item label="投诉编号" label-align="right" align="left" :span="2">{{ complaintInfo.complaintCode }}</el-descriptions-item>
            <el-descriptions-item label="项目名称" label-align="right" align="left" :span="2">{{ complaintInfo.projectName }}</el-descriptions-item>
            <el-descriptions-item label="总包单位" label-align="right" align="left" :span="2">{{ complaintInfo.generalContractor }}</el-descriptions-item>
            <el-descriptions-item label="分包单位" label-align="right" align="left" :span="2">{{ complaintInfo.subcontractor }}</el-descriptions-item>
            <el-descriptions-item label="投诉人姓名" label-align="right" align="left" :span="1">{{ complaintInfo.userId }}</el-descriptions-item>
            <el-descriptions-item label="联系方式" label-align="right" align="left" :span="1">{{ complaintInfo.phone }}</el-descriptions-item>
            <el-descriptions-item label="班组/工种" label-align="right" align="left" :span="2">{{ complaintInfo.position }}</el-descriptions-item>
            <el-descriptions-item label="班组联系人" label-align="right" align="left" :span="1">{{ complaintInfo.positionName }}</el-descriptions-item>
            <el-descriptions-item label="班组联系方式" label-align="right" align="left" :span="1">{{ complaintInfo.positionPhone }}</el-descriptions-item>
            <el-descriptions-item label="欠薪金额" label-align="right" align="left" :span="2">{{ complaintInfo.arrearsAmount }}<span v-if="complaintInfo.arrearsAmount">元</span></el-descriptions-item>
            <el-descriptions-item label="欠薪期间" label-align="right" align="left" :span="2">{{ complaintInfo.wageArrearsStart }} <span style="margin: 0 6px">至</span> {{ complaintInfo.wageArrearsEnd }}</el-descriptions-item>
            <el-descriptions-item label="投诉来源" label-align="right" align="left" :span="1">{{ ['扫码投诉', '扫码投诉'][complaintInfo.complaintSource] || '扫码投诉' }}</el-descriptions-item>
            <el-descriptions-item label="分派状态" label-align="right" align="left" :span="1">{{ ['未分派','一级已分派','二级已分派'][complaintInfo.assignStatus] || "" }}</el-descriptions-item>
            <el-descriptions-item label="处理状态" label-align="right" align="left" :span="1">
              <template v-if="complaintInfo.validInvalid === 1">
                已标记无效
              </template>
              <template v-else>
                {{['处理中','已处理','已退回'][complaintInfo.processStatus] || '处理中' }}
              </template>
            </el-descriptions-item>
            <el-descriptions-item label="结案状态" label-align="right" align="left" :span="1">{{ ['未结案','已结案','已退回'][complaintInfo.caseStatus] || "" }}</el-descriptions-item>
            <el-descriptions-item label="提交时间" label-align="right" align="left" :span="2">{{ complaintInfo.createTime }}</el-descriptions-item>
            <el-descriptions-item label="备注/补充说明" label-align="right" align="left" :span="2">{{ complaintInfo.remarks }}</el-descriptions-item>
            <el-descriptions-item label="附件" label-align="right" align="left" :span="2">
              <MyFileList :fileList="complaintInfo.attachments" :columns="7"></MyFileList>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="detail-log-flow">
          <MyTitle title="处置信息" :mt0="true" marginLeft="0px" />
          <MyTimeLine :cardList="recordList" :complaintInfo="complaintCopy" @handleUpdateData="handleOpen(complaintCopy)"></MyTimeLine>
        </div>
      </div>
      <template slot="footer">
        <el-button @click="handleClose">关闭</el-button>
      </template>
    </MyModal>
  </template>
  
  <script>
  import MyModal from "@/components/myComponents/MyModal/index.vue";
  import MyTitle from "@/components/myComponents/MyTitle/index.vue";
  import MyTimeLine from "@/components/myComponents/MyTimeLine/index.vue";
  import MyFileList from "@/components/myComponents/MyFileList/index.vue";
  import {getComplaintDetail, getRecodList} from "@/api/unpaidWages/complaint";
  
  export default {
    name: 'ExceptionDetailModal',
    components: {
      MyModal,
      MyTitle,
      MyTimeLine,
      MyFileList
    },
    data() {
      return {
        complaintInfo: {},
        complaintCopy: {},
        recordList: []
      }
    },
    methods: {
      async handleOpen(complaint) {
        console.log(complaint,'complaint')
        try {
          // 确保 complaint 参数有效
          if (!complaint || !complaint.id) {
            console.error('投诉信息无效，无法打开详情');
            return;
          }
          
          this.complaintCopy = complaint || {};
          const complaintId = complaint.id;
          
          // 获取recordList 和基本信息
          const res = await getRecodList({complaintId: complaintId});
          // 确保 recordList 能正确处理响应结构
          const recordData = res?.data?.data || res?.data || [];
          this.recordList = (Array.isArray(recordData) ? recordData : []).map((item) => {
            return {
              ...item,
              fileList: !item.recordFileList || !item.recordFileList.length ? [] : item.recordFileList.map((file) => {
                if (typeof file === "object") return file;
                return {
                  fileName: file.split("/")[file.split("/").length - 1],
                  fileUrl: file,
                  path: file
                }
              })
            }
          });

          const complaintRes = await getComplaintDetail({id: complaintId});
          // 确保 complaintInfo 始终是一个对象，避免 undefined 错误
          this.complaintInfo = complaintRes?.data || {};
          // 对附件列表做个处理
          console.log(res.data, complaintRes.data)

          this.$refs.myModalRef.handleOpen();
        } catch (error) {
          console.error('打开详情失败:', error);
        }
      },

      handleClose() {
        this.$refs.myModalRef.handleClose();
      },

      handleDirectlyClose() {
        this.$refs.myModalRef.handleDirectlyClose();
      }
    }
  }
  </script>
  
  <style lang="scss">
  .detail-box-uniq-1232311 {
    display: flex;
    height: fit-content;

    .detail-main-info {
      width: 646px;
      margin-right: 44px;
    }

    .detail-log-flow {
      flex: 1;
      height: auto;
      display: flex;
      flex-direction: column;
    }
    .el-descriptions__label {
      width: 120px;
      background-color: rgb(237, 246, 252)!important;
    }
    .el-descriptions__content {
      background-color: rgb(249, 250, 251)!important;
    }
  }
  </style>
